import { render, staticRenderFns } from "./DetailsDealModal.vue?vue&type=template&id=2b2681e2&scoped=true&"
import script from "./DetailsDealModal.vue?vue&type=script&lang=js&"
export * from "./DetailsDealModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailsDealModal.vue?vue&type=style&index=0&id=2b2681e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2681e2",
  null
  
)

export default component.exports